import { deserialize, serialize } from "cerialize";
import TUKDashboardBreakdown from "./TUKDashboardBreakdown";
import { serializeAs } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKDashboardSummary implements EntityAware {

    @serialize
    @deserialize
    public total_saldo: number = 0;

    @serializeAs(TUKDashboardBreakdown)
    @serializeAs(TUKDashboardBreakdown)
    public breakdown: TUKDashboardBreakdown[] = [];
}
